import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ConfigManagerService } from './shared/services/config-manager.service';
import { APP_SETTINGS, AppSettings } from './app-settings';
import { AppRoutingModule } from './app-routing.module';
import { ErrorModule } from './error/error.module';
import { AppComponent } from './app.component';
import { CoreModule } from './shared/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AlertModule } from './alerts/store/alert.module';
import { UtilModule } from './utils/store/utils.module';
import { LayoutModule } from './layouts/layout.module';
import { AuthModule } from './auth/auth.module';
import { eventReducer } from './events/store/events-list/event.actions';
import { initialEventState } from './events/store/event.state';
import { initialHistoryState } from './events/store/history.state';
import { historyReducer } from './events/store/history-details/history-details.action';
import { extModules } from './build-specifics';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { SortableModule } from '@progress/kendo-angular-sortable';

export function configManagerServiceFactory(
    configManager: ConfigManagerService
): Function {
    return () => configManager.init();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,

        // Quotient Modules
        AlertModule,
        UtilModule,
        CoreModule,
        LayoutModule,
        ErrorModule,
        AuthModule,
        AppRoutingModule, // App routing should always be last for route matching hierarchy

        // Vendor Modules
        NgxWebstorageModule.forRoot({ prefix: 'qm' }),
        StoreModule.forRoot({
            router: routerReducer
        }),
        EffectsModule.forRoot([]),

        StoreModule.forFeature('event', eventReducer, {
            initialState: initialEventState
        }),
        StoreModule.forFeature('history', historyReducer, {
            initialState: initialHistoryState
        }),
        ...extModules,
        StoreRouterConnectingModule.forRoot(),
        BrowserAnimationsModule,
        SortableModule
    ],
    providers: [
        ConfigManagerService,
        {
            provide: APP_INITIALIZER,
            useFactory: configManagerServiceFactory,
            deps: [ConfigManagerService],
            multi: true
        },
        {
            provide: APP_SETTINGS,
            useValue: AppSettings
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
